var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"container-products",style:({'--total': _vm.familyProducts.lenght}),attrs:{"tag":"section","name":"fade-in-right-group","mode":"out-in"}},_vm._l((_vm.familyProducts),function(products){return _c('ProductLayout',{key:products.id,attrs:{"products":products}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }